



















import { DeliveryConfigState, DeliveryMethod } from '@/models/delivery'
import SetDeliveryConfig from '@spa/components/pages/order/edit/delivery/SetDeliveryConfig.vue'
import { PluginMixin } from '@spa/mixins/plugin'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component({
  components: {
    SetDeliveryConfig,
  },
})
export default class DeliveryConfigList extends Mixins<PluginMixin>(
  PluginMixin
) {
  @Prop({ required: true })
  configList: DeliveryConfigState[]

  @Prop({ required: true })
  canSelectDeliveryPeriod: boolean

  @Emit('change-delivery-config')
  onChangeDeliveryConfig(_c: DeliveryConfigState) {
    // do nothing
  }

  @Emit('change-delivery-method')
  onChangeDeliveryMethod(_c: DeliveryConfigState, _dm: DeliveryMethod) {
    // do nothing
  }
}
